import React from 'react';
import { Modal, WizardStep, WizardFooter} from 'shared-portal-components-v2';

import { classNames } from '@/utils/classNames.utils';
import type { WizardStepStatus } from '@/types/create-six.types';

export interface CreateSixWizardStepDefinition {
  stepNumber: number;
  label: string;
  status: WizardStepStatus;
  isDisabled?: boolean;
  onClick?: () => void;
}

export interface CreateSixWizardModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: React.ReactNode;
  isLoading?: boolean;
  steps: CreateSixWizardStepDefinition[];
  isFirstStep: boolean;
  isLastStep: boolean;
  isNextDisabled?: boolean;
  nextDisabledTooltip?: string;
  finalButtonText?: string;
  nextButtonText?: string;
  onPrevious: () => void;
  onNext: () => void;
  onCancel: () => void;
  children: React.ReactNode;
  bodyClassName?: string;
}

function CreateSixWizardModal(props: CreateSixWizardModalProps): React.JSX.Element | null {
  const {
    isOpen,
    onClose,
    title,
    isLoading = false,
    steps,
    isFirstStep,
    isLastStep,
    isNextDisabled = false,
    nextDisabledTooltip,
    finalButtonText,
    nextButtonText,
    onPrevious,
    onNext,
    onCancel,
    children,
    bodyClassName,
  } = props;

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      panelClassName={classNames('!w-full !max-w-5xl flex flex-col gap-4 max-h-[min(800px,90dvh)]')}
    >
      <div className="space-y-3 flex-shrink-0 pb-4">
        <div className="flex justify-between items-center">
          {steps.map((stepDefinition) => (
            <WizardStep
              key={`${String(stepDefinition.stepNumber)}-${stepDefinition.label}`}
              step={stepDefinition.stepNumber}
              label={stepDefinition.label}
              status={stepDefinition.status}
              onClick={stepDefinition.onClick}
              isDisabled={stepDefinition.isDisabled}
            />
          ))}
        </div>
      </div>

      <div className={classNames('flex-1 p-6 min-h-0 overflow-y-auto overflow-x-hidden', bodyClassName)}>
        {children}
      </div>

      <div className="pt-4">
        <WizardFooter
          isFirstStep={isFirstStep}
          isLastStep={isLastStep}
          onPrevious={onPrevious}
          onNext={onNext}
          onCancel={onCancel}
          isLoading={isLoading}
          isNextDisabled={isNextDisabled}
          nextDisabledTooltip={nextDisabledTooltip}
          finalButtonText={finalButtonText}
          nextButtonText={nextButtonText}
        />
      </div>
    </Modal>
  );
}

export default CreateSixWizardModal;
